import { rescheduleVisit } from '../../../store/new-visit/NewVisitThunk'

export const useReschedulePrimaryClick = ({
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  showReviewBook,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  setShowReviewBook,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  visitOptions,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  dispatch,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  state,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  currentTimeZone,
}) => {
  const reschedulePrimaryClick = () => {
    const { providerId, providerName, dateTime } = visitOptions.providerInfo || {}
    if (!showReviewBook) {
      setShowReviewBook(true)
    } else {
      dispatch(
        rescheduleVisit({
          visitId: state.bookingId,
          requestData: {
            TimeZone: state.customTimeZone || currentTimeZone,
            Method: visitOptions.selectedMethod,
            DateTime: dateTime,
            ProviderId: providerId,
            ProviderName: providerName,
          },
        }),
      )
    }
  }

  return reschedulePrimaryClick
}
